import { IdleQueue } from 'idlize/IdleQueue';
/* Class that represents the redux beacon target to track Google Tag Manager events */
class GoogleTagManager {
  constructor() {
    this.events = [];
    this.queue = new IdleQueue({ ensureTasksRun: true });

    this.target = (events) => {
      this.startTime = this.startTime || +new Date();
      this.events = [...this.events, ...events];
      this.queue.pushTask(this.trackEvent.bind(this));
    };
  }

  /* Function to track the event that will have the time from when starts to queue and will stop after 15000ms */
  trackEvent() {
    const timeLapsed = +new Date() - this.startTime;
    const isTimeExpired = timeLapsed < 15000;

    /* If data layer is not defined and the time has not expired we shouldnt queue the event again */
    if (!window.dataLayer && isTimeExpired) {
      this.queue.pushTask(this.trackEvent.bind(this));
      return;
    }

    /* The event is not in queue anymore because the time has passed BUT the we need to continue to 
      validate the datalayer */
    if (!window.dataLayer) {
      this.events = [];
      return;
    }

    while (this.events.length !== 0) {
      const event = this.events.shift();
      window.dataLayer.push(event);
      window.dataLayer.push({ params: null });
    }

    this.startTime = +new Date();
  }

  /* Gets event target */
  getTarget() {
    return this.target;
  }
}

export default GoogleTagManager;
